import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1559013f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "w-full" }

import { ComputedRef, PropType, computed } from 'vue';
import { ListFilterButtonVariant } from '@/enums/list-filter';
import AppTooltip from '@/components/Base/AppTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilterButton',
  props: {
  variant: {
    type: String as PropType<ListFilterButtonVariant>,
    default: ListFilterButtonVariant.DEFAULT,
  },
  tooltip: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: {
  click: null,
},
  setup(__props, { emit }) {

const props = __props;





const buttonVariantClassMap: ComputedRef<Record<ListFilterButtonVariant, string>> = computed(
  (): Record<ListFilterButtonVariant, string> => ({
    [ListFilterButtonVariant.DEFAULT]: 'button-variant-default',
    [ListFilterButtonVariant.LIGHT]: 'button-variant-light',
    [ListFilterButtonVariant.BRAND]: 'button-variant-brand',
  }),
);

const buttonClick = (): void => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      [_unref(buttonVariantClassMap)[props.variant]]: true,
      'flex min-h-[32px] rounded border border-dark-100': true,
      'opacity-75 brightness-75': props.disabled,
    })
  }, [
    _createElementVNode("button", {
      type: "button",
      disabled: props.disabled,
      class: _normalizeClass({
        'border-lighten w-full rounded border-t py-1 px-2 text-sm -outline-offset-1': true,
        'hocus:bg-lighten-sm cursor-pointer': !props.disabled,
        'cursor-not-allowed': props.disabled,
      }),
      onClick: buttonClick
    }, [
      _createVNode(AppTooltip, {
        placement: "bottom",
        disabled: !props.tooltip
      }, {
        popper: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.tooltip), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["disabled"])
    ], 10, _hoisted_1)
  ], 2))
}
}

})